export enum NAVIGATION_ADMIN {
    /**
     * @value Add navigation item
     * @description Text to be displayed on an action that will add a new navigation item
     */
    ADD_NAVIGATION_ITEM = 'NAVIGATION_ADMIN.ADD_NAVIGATION_ITEM',
    /**
     * @value These settings will only affect the navigation item and will not override community settings.
     */
    COMMUNITY_DESCRIPTION = 'NAVIGATION_ADMIN.COMMUNITY_DESCRIPTION',
    /**
     * @value These settings will only affect the navigation item and will not override content settings.
     */
    CONTENT_DESCRIPTION = 'NAVIGATION_ADMIN.CONTENT_DESCRIPTION',
    /**
     * @value Separate classes with comma. Classes will be prefixed by 'main-nav__child--'.
     */
    CUSTOM_CODE_ITEM_CLASSES_HELPER = 'ADMIN.MAIN_NAV.STYLE_CLASSES_HELP',
    /**
     * @value Navigation item classes
     * @description Title of the field for an user to add their custom css classes to a navigation item
     */
    CUSTOM_CODE_ITEM_CLASSES_TITLE = 'NAVIGATION_ADMIN.CUSTOM_CODE_ITEM_CLASSES_TITLE',
    /**
     * @value Navigation item identifier
     * @description Title of the field for an user to add their custom html identifier to a navigation item
     */
    CUSTOM_CODE_ITEM_IDENTIFIER_TITLE = 'NAVIGATION_ADMIN.CUSTOM_CODE_ITEM_IDENTIFIER_TITLE',
    /**
     * @value This item will only be visible for people with selected languages and be hidden for others.
     * @description Description shown on the "display only for languages" field of the navigation item edition modal.
     */
    DISPLAY_ONLY_FOR_LANGUAGES_DESCRIPTION = 'NAVIGATION_ADMIN.DISPLAY_ONLY_FOR_LANGUAGES_DESCRIPTION',
    /**
     * @value Edit navigation item
     */
    EDIT_NAVIGATION_ITEM = 'NAVIGATION_ADMIN.EDIT_NAVIGATION_ITEM',
    /**
     * @value Organize content to define the main navigation
     * @description Description text asking to define the main navigation (in an administration page) when it is currently empty
     */
    EMPTY_LIST_DESCRIPTION = 'NAVIGATION_ADMIN.EMPTY_LIST_DESCRIPTION',
    /**
     * @value Define the main navigation
     * @description Description title asking to define the main navigation (in an administration page), when it is currently empty
     */
    EMPTY_LIST_TITLE = 'NAVIGATION_ADMIN.EMPTY_LIST_TITLE',
    /**
     * @value External link
     * @description In Mobile Navigation admin page, the title of the dialog to add external links as navigation item.
     */
    EXTERNAL_LINK = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.DIALOG_TITLE',
    /**
     * @value Use only external links. Do not use an internal link from Lumapps, add a content navigation item instead.
     */
    EXTERNAL_LINK_DESCRIPTION = 'NAVIGATION_ADMIN.EXTERNAL_LINK_DESCRIPTION',
    /**
     * @value Link title
     */
    EXTERNAL_LINK_TITLE = 'NAVIGATION_ADMIN.EXTERNAL_LINK_TITLE',
    /**
     * @value as:
     * @description "as" word used as label of the "group" filter of the navigation administration page when there is both "language" and "group" filter displayed.
     *
     * If the phrasing doesn't work in a perticular language, it can be translated to "Filter by group".
     */
    FILTER_AS = 'NAVIGATION_ADMIN.FILTER_AS',
    /**
     * @value Show in:
     * @description Label of the "language" filter of the navigation administration page.
     * Ex: Show in english
     */
    FILTER_SHOW_IN = 'NAVIGATION_ADMIN.FILTER_SHOW_IN',
    /**
     * @value Only hide this navigation item children in the main navigation
     * @description Checkbox label to toggle to hide navigation item children in the main navigation
     */
    HIDE_CHILDREN_IN_MAIN_NAV = 'NAVIGATION_ADMIN.HIDE_CHILDREN_IN_MAIN_NAV',
    /**
     * @value Hide this navigation item in the main navigation
     * @description Label for a checkbox to toggle hiding a navigation item in the main navigation
     */
    HIDE_IN_MAIN_NAV = 'NAVIGATION_ADMIN.HIDE_IN_MAIN_NAV',
    /**
     * @value Also hide children of this navigation item
     * @description Helper text explaining what the checkbox does on top of hiding the navigation item from the main navigation
     */
    HIDE_IN_MAIN_NAV_HELPER = 'NAVIGATION_ADMIN.HIDE_IN_MAIN_NAV_HELPER',
    /**
     * @value Hide title in the main navigation
     * @description Title of the settings that let the user set a Navigation element as hidden in the Main navigation
     */
    HIDE_TITLE_IN_MAIN_NAVIGATION = 'NAVIGATION_ADMIN.HIDE_TITLE_IN_MAIN_NAVIGATION',
    /**
     * @value If left empty, the navigation item title will be the same as the community title.
     * @description A helper for a dialog field explaining how filling this field works
     */
    ITEM_TITLE_HELPER_COMMUNITY = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_COMMUNITY',
    /**
     * @value If left empty, the navigation item title will be the same as the content title.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with Content List
     */
    ITEM_TITLE_HELPER_CONTENT = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_CONTENT',
    /**
     * @value If left empty, the navigation item title will be the same as the content list title.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with Content
     */
    ITEM_TITLE_HELPER_CUSTOM_LIST = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_CUSTOM_LIST',
    /**
     * @value If left empty, the navigation item title will be the same as the directory title.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with User Directory
     */
    ITEM_TITLE_HELPER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_DIRECTORY',
    /**
     * @value If left empty, the navigation item title will be the same as the user directory title.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with Directory
     */
    ITEM_TITLE_HELPER_USER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_USER_DIRECTORY',
    /**
     * @value Navigation item visibility
     */
    ITEM_VISIBILITY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY',
    /**
     * @value If left empty, navigation item will be only visible to users for whom the community is visible.
     * @description A helper for a dialog field explaining how filling this field works
     */
    ITEM_VISIBILITY_HELPER_COMMUNITY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_COMMUNITY',
    /**
     * @value If left empty, navigation item will be only visible to users for whom the piece of content is visible.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with Content List
     */
    ITEM_VISIBILITY_HELPER_CONTENT = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_CONTENT',
    /**
     * @value If left empty, navigation item will be only visible to users for whom the content list is visible.
     * @description A helper for a dialog field explaining how filling this field works
     *
     *
     * NOTE: translation to not confuse with Content
     */
    ITEM_VISIBILITY_HELPER_CUSTOM_LIST = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_CUSTOM_LIST',
    /**
     * @value If left empty, navigation item will be only visible to users for whom the directory is visible.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with User Directory
     */
    ITEM_VISIBILITY_HELPER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_DIRECTORY',
    /**
     * @value If left empty, navigation item will be only visible to users for whom the user directory is visible.
     * @description A helper for a dialog field explaining how filling this field works
     *
     * NOTE: translation to not confuse with Directory
     */
    ITEM_VISIBILITY_HELPER_USER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_USER_DIRECTORY',
    /**
     * @value This item will not appear in the navigation
     * @description Text indicating that a navigation item will not appear in the navigation menu
     */
    ITEM_WILL_NOT_APPEAR_IN_NAVIGATION = 'NAVIGATION_ADMIN.ITEM_WILL_NOT_APPEAR_IN_NAVIGATION',
    /**
     * @value Journey
     * @description A "journey" is some kind of "process" through which employees can go through. For example there can be an "onboarding" journey, where an employee gets its employee credentials, work computer, etc.
     */
    JOURNEY = 'NAVIGATION_ADMIN.JOURNEY',
    /**
     * @value Journeys from your site
     * @description A "journey" is some kind of "process" through which employees can go through. For example there can be an "onboarding" journey, where an employee gets its employee credentials, work computer, etc.
     */
    JOURNEY_DESCRIPTION = 'NAVIGATION_ADMIN.JOURNEY_DESCRIPTION',
    /**
     * @value Item cannot be moved. There is no other section to move the item to.
     */
    MOVE_DISABLED_NO_SECTION = 'NAVIGATION_ADMIN.MOVE_DISABLED_NO_SECTION',
    /**
     * @value Item cannot be moved. It is the only item in this section.
     */
    MOVE_DISABLED_ONLY_ELEMENT = 'NAVIGATION_ADMIN.MOVE_DISABLED_ONLY_ELEMENT',
    /**
     * @value Navigation item title
     * @description Title of the field to override the navigation item title.
     */
    NAVIGATION_ITEM_TITLE = 'NAVIGATION_ADMIN.NAVIGATION_ITEM_TITLE',
    /**
     * @value Navigation item visibility is public
     * @description Used as an option in a form so when the user select this option, the navigation will become item visibility will become public
     */
    NAVIGATION_ITEM_VISIBILITY_IS_PUBLIC = 'NAVIGATION_ADMIN.NAVIGATION_ITEM_VISIBILITY_IS_PUBLIC',
    /**
     * @value You are not allowed to add content to this section.
     * @description Message displayed to the user to explain they cannot add a node item to the  selected section.
     */
    NOT_ALLOWED_TO_ADD_CONTENT_TO_SECTION = 'NAVIGATION_ADMIN.NOT_ALLOWED_TO_ADD_CONTENT_TO_SECTION',
    /**
     * @value Personal Feed
     */
    PERSONAL_FEED = 'NAVIGATION_ADMIN.PERSONAL_FEED',
    /**
     * @value User personal feed from your platform
     */
    PERSONAL_FEED_DESCRIPTION = 'NAVIGATION_ADMIN.PERSONAL_FEED_DESCRIPTION',
    /**
     * @value Pick an existing article.
     */
    PICK_ARTICLE_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_ARTICLE_DESCRIPTION',
    /**
     * @value Pick communities from all platform sites
     * @description Description of the "pick communities" option listed in the "add element" dialog
     */
    PICK_COMMUNITY_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_COMMUNITY_DESCRIPTION',
    /**
     * @value Pick content from your platform
     * @description Description of the "pick content" option listed in the add element dialog
     */
    PICK_CONTENT_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_CONTENT_DESCRIPTION',
    /**
     * @value Content type lists from your platform
     * @description Description of the "content list" option of the navigation item wizard.
     */
    PICK_CONTENT_LIST_DESCRIPTION = 'NAVIGATION_ADMIN.PICK_CONTENT_LIST_DESCRIPTION',
    /**
     * @value Directories from your platform
     * @description Description of the "directory" option of the new navigation item dialog.
     *
     */
    PICK_DIRECTORY_DESCRIPTION = 'NAVIGATION_ADMIN.PICK_DIRECTORY_DESCRIPTION',
    /**
     * @value Link external content with URL
     * @description Description of the "pick external content" option listed in the "add element" dialog
     */
    PICK_EXTERNAL_CONTENT_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_EXTERNAL_CONTENT_DESCRIPTION',
    /**
     * @value User directories from your platform
     * @description Description of the "user directory" option of the new navigation item dialog.
     */
    PICK_USER_DIRECTORY_DESCRIPTION = 'NAVIGATION_ADMIN.PICK_USER_DIRECTORY_DESCRIPTION',
    /**
     * @value Restrict navigation item visibility
     * @description Title of a field in an administration dialog where you can restrict the navigation item visibility by groups
     */
    RESTRICT_ITEM_VISIBILITY = 'NAVIGATION_ADMIN.RESTRICT_ITEM_VISIBILITY',
    /**
     * @value Section
     * @description Type of navigation item.
     */
    SECTION = 'NAVIGATION_ADMIN.SECTION',
    /**
     * @value Sections allow grouping elements. A new navigation item will be created in the menu.
     */
    SECTION_DESCRIPTION = 'NAVIGATION_ADMIN.SECTION_DESCRIPTION',
    /**
     * @value Section title
     * @description text to be displayed on the navigation admin as a label for the section title textfield
     */
    SECTION_TITLE = 'NAVIGATION_ADMIN.SECTION_TITLE',
    /**
     * @value Some elements are hidden because the filter "Show only visible items" is activated.
     * @description Message displayed on the main navigation admin when the "show only visible items" is switched on. The message warns the user that some items will be not be visible.
     */
    SHOW_ONLY_VISIBLE_ACTIVATED_WARNING = 'NAVIGATION_ADMIN.SHOW_ONLY_VISIBLE_ACTIVATED_WARNING',
    /**
     * @value These settings will only affect the navigation item and will not override space settings.
     */
    SPACE_DESCRIPTION = 'NAVIGATION_ADMIN.SPACE_DESCRIPTION',
    /**
     * @value Hide items to create a sub-navigation using the sub-navigation widget on a page
     * @description Infobox message explaining the "Use as sub nav" section in a main navigation parameter dialog
     */
    USE_AS_SUB_NAV_DESCRIPTION = 'NAVIGATION_ADMIN.USE_AS_SUB_NAV_DESCRIPTION',
    /**
     * @value Use as sub-navigation
     * @description Section title in a main nav parameters dialog
     */
    USE_AS_SUB_NAV_TITLE = 'NAVIGATION_ADMIN.USE_AS_SUB_NAV_TITLE',
    /**
     * @value Video gallery from your site
     */
    VIDEO_GALLERY_DESCRIPTION = 'NAVIGATION_ADMIN.VIDEO_GALLERY_DESCRIPTION',
}
